<template>
  <div>
    <div class="auth-wrapper-provider">
      <AuthWrapper
        :rightIcon="!!items.length || loading ? 'arrow-right' : ''"
        :showLogo="!!items.length || loading"
        @handleRightIcon="goToAuth"
      >
        <template #main v-if="items.length || loading">
          <b-row v-if="items.length || loading">
            <b-col cols="12" md="12" class="margin-bottom-16">
              <Alert :text="$lang.coursesListSubtitle" />
            </b-col>
            <b-col cols="12" md="12" class="margin-bottom-8">
              <div class="font-size-12 color-complementary-300">
                {{ $lang.select_your_term }}
              </div>
            </b-col>
          </b-row>
          <b-row v-if="loading">
            <b-col
              cols="12"
              md="12"
              class="margin-bottom-8"
              v-for="(item, index) in [1, 2, 3]"
              :key="index"
            >
              <div
                class="flex-between padding-x-16 padding-y-8 border-radius-8 border--solid border--complementary-50"
              >
                <b-skeleton width="60%"></b-skeleton>
                <b-skeleton height="28px" type="button"></b-skeleton>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="!loading">
            <b-col
              cols="12"
              md="12"
              class="margin-bottom-8"
              v-for="(item, index) in items"
              :key="index"
            >
              <ActiveRegisterItem :item="item" />
            </b-col>
          </b-row>
        </template>
        <template #main v-else>
          <b-row>
            <b-col cols="12" md="12" class="text-center margin-bottom-16">
              <b-img
                :src="$config.images.shared.redesign.empty.activeRegistrations"
                width="180"
              />
            </b-col>
            <b-col cols="12" md="12" class="flex-center margin-bottom-16">
              <div
                class="font-size-14 color-complementary-300 max-width-180 text-center"
              >
                {{ $lang.no_active_registrations_record }}
              </div>
            </b-col>
            <b-col cols="12" md="12" class="text-center">
              <Button
                class="min-width-180"
                contentClass="justify-content-center"
                variant="outline-primary"
                :text="$lang.back_to_login"
                @click="goToAuth"
              />
            </b-col>
          </b-row>
        </template>
      </AuthWrapper>
    </div>
  </div>
</template>

<script>
import { AuthWrapper, Alert } from "@/components/re-design";
import { Button } from "@/components/re-design/forms";
import ActiveRegisterItem from "../components/ActiveRegisterItem.vue";
import { pathOr } from "ramda";
import { generateApiUrl, goToRoute } from "@/shared/utils";
import { getActiveRegistrations } from "@/modules/auth/services";

export default {
  components: {
    AuthWrapper,
    Alert,
    Button,
    ActiveRegisterItem,
  },
  data() {
    return {
      loading: false,
      items: [],
    };
  },
  mounted() {
    this.getActiveRegistrationsList();
  },
  methods: {
    pathOr,
    generateApiUrl,
    goToRoute,
    goToAuth() {
      goToRoute("auth", {}, {}, false);
    },
    async getActiveRegistrationsList() {
      try {
        this.loading = true;
        const response = await getActiveRegistrations();
        const { activeRegistrations } = response;
        this.items = activeRegistrations;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
